import './imageGallery.html.twig';
import './imageGallery.css';

export default function() {
  document.querySelectorAll('.image-gallery').forEach(gallery => {
    if (!gallery) {
      return;
    }
    let activeImage;

    gallery.querySelector('.image-gallery__carousel li:first-child').classList.add('selected');

    const intersectionObserver = new IntersectionObserver(
      entries => {
        const el = entries
          .filter(e => e.isIntersecting)
          .map(e => e.target)
          .shift();
        if (el) {
          gallery.querySelector('.image-gallery__carousel .selected').classList.remove('selected');
          activeImage = el;
          const index = [...el.parentElement.children].findIndex(e1 => e1 === el);
          const carouselSelected = gallery.querySelector(`.image-gallery__carousel > :nth-child(${index + 1})`);

          carouselSelected.classList.add('selected');
        }
      },
      {
        root: gallery.querySelector('.image-gallery__main'),

        // Chrome is drawing the root container for me at 969.656px wide.
        // but whilst the intersectionRect comes in at that width, the
        // boundingClientRect is rounded to 970px. That tiny difference causes the
        // ratio to drop just slightly below 1 to 0.9996455907821655.
        // Adding a 1px root margin recovers that space just enough to fix the
        // rounding error.
        rootMargin: '1px',
        threshold: 1,
      }
    );

    gallery.querySelectorAll('.image-gallery__main li').forEach(el => {
      intersectionObserver.observe(el);
    });

    gallery.querySelectorAll('.image-gallery__carousel li').forEach(el => {
      el.addEventListener('click', () => {
        const index = [...el.parentElement.children].findIndex(e1 => e1 === el);
        gallery
          .querySelector(`.image-gallery__main > :nth-child(${index + 1})`)
          .scrollIntoView({ inline: 'center', block: 'nearest' });
      });
    });

    gallery.querySelector('.image-gallery__texture-right__button').addEventListener('click', () => {
      if (activeImage.nextElementSibling) {
        activeImage = activeImage.nextElementSibling;
        activeImage.scrollIntoView({ inline: 'center', block: 'nearest' });
        // Updating immediately allows multiple clicks before the animation completes.
      }
    });

    gallery.querySelector('.image-gallery__texture-left__button').addEventListener('click', () => {
      if (activeImage.previousElementSibling) {
        activeImage = activeImage.previousElementSibling;
        activeImage.scrollIntoView({ inline: 'center', block: 'nearest' });
        // Updating immediately allows multiple clicks before the animation completes.
      }
    });

    gallery.querySelector('.image-gallery__carousel__button--right').addEventListener('click', () => {
      const c = gallery.querySelector('.image-gallery__carousel');
      c.scrollBy({ left: c.clientWidth });
    });

    gallery.querySelector('.image-gallery__carousel__button--left').addEventListener('click', () => {
      const c = gallery.querySelector('.image-gallery__carousel');
      c.scrollBy({ left: -c.clientWidth });
    });

    arrows(
      gallery.querySelector('.image-gallery__main'),
      gallery.querySelector('.image-gallery__texture-left__button-bg'),
      gallery.querySelector('.image-gallery__texture-right__button-bg'),
      'image-gallery__button--visible'
    );
    arrows(
      gallery.querySelector('.image-gallery__carousel'),
      gallery.querySelector('.image-gallery__carousel__button--left'),
      gallery.querySelector('.image-gallery__carousel__button--right'),
      'image-gallery__carousel__button--visible'
    );
  });
}

function arrows(box, arrowLeft, arrowRight, toggleClass) {
  box.addEventListener('scroll', handler);
  handler();

  function handler() {
    if (box.scrollWidth === box.offsetWidth) {
      arrowLeft.classList.remove(toggleClass);
      arrowRight.classList.remove(toggleClass);
    } else if (box.scrollLeft === 0) {
      arrowLeft.classList.remove(toggleClass);
      arrowRight.classList.add(toggleClass);
    } else if (box.scrollLeft + box.offsetWidth === box.scrollWidth) {
      arrowLeft.classList.add(toggleClass);
      arrowRight.classList.remove(toggleClass);
    } else {
      arrowRight.classList.add(toggleClass);
      arrowLeft.classList.add(toggleClass);
    }
  }
}
